import * as React from "react";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Navbar } from "../components/navbar";
import type { RouterContext } from "../lib/router";
import { useAuthContext } from "../lib/use-auth";
import { ToastContainer } from "react-toastify";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const authState = useAuthContext();

  return (
    <React.Fragment>
      {authState.state === "PENDING" && (
        <div className="h-full flex items-center justify-center">
          <span className="loading loading-spinner loading-xl"></span>
        </div>
      )}
      {authState.state === "AUTHENTICATED" && (
        <>
          <Navbar user={authState.user} signOut={authState.signOut} />
          <Outlet />
        </>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
      />
    </React.Fragment>
  );
}
